// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b3d0d72","239":"03cc93c3","667":"b82a1d3f"}[chunkId] + ".chunk.js";
};